import React, {FunctionComponent} from "react";
import WizardStep from "../WizardStep";
import statusAditionalInfo from "../../../images/Progress/progress_beschreibung.svg";
import {TextField} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {setComments} from "../../state/disposalSlice";
import {Step} from "../../WizardMap";
import {RootState} from "../../../redux/rootReducer";
import {NavigationProps} from "../../slideRouter/navigationHook";

const StepAdditionalInfo: FunctionComponent<NavigationProps> = ({gotoPrevSlide, gotoNextSlide}) => {

    const dispatch = useDispatch();

    const {comments} = useSelector((state: RootState) => state.disposal.currentDisposal);

    const onAdditionalInfoChange = (value: string) => dispatch(setComments(value));

    return (
        <WizardStep
            title={"Möchten Sie eigene Angaben machen?"}
            description={"Angaben, die den Wert steigern könnten,\nwie z.B.: Ursprung, Zertifikate, Besonderheiten etc."}
            icon={statusAditionalInfo}
            backButton={true}
            onBackClick={gotoPrevSlide}
            nextButton={true}
            onNextClick={() => gotoNextSlide(Step.PHOTO)}
        >
            <TextField
                label={"Beschreibung (optional)"}
                margin={"none"}
                defaultValue={comments}
                multiline={true}
                onChange={({target}) => onAdditionalInfoChange(target.value)}
                style={{width: 260, marginTop: "15%", padding: 0}}
                InputLabelProps={{style: {color: "#999"}}}
                InputProps={{style: {color: "#000"}}}
            />
        </WizardStep>
    );
};

export default StepAdditionalInfo;
